import styled from "@emotion/styled";
import {ReactComponent as iconCallList} from "../../../../images/800CallLogs/Resources for Call Logs/IconCallList.svg"

export const IconCallList = styled(iconCallList)`
     width: 26px;
     height: 26px;
`;